module.exports = __webpack_public_path__ + "ruby.svg";